export class DtoUnidadMedida {
    ID_UnidadMedida: number = 0;
    Nombre: string = '';
}